import React from "react";
import Link from "@mui/material/Link";
import {CPSConstants} from "commonUtils/enumerations";

interface Props {
  href?: string;
  target?: string;
  outlet: string;
  className?: string;
}

const FormLink: React.FC<Props> = ({href, target, outlet, className}) => {
  return (
    <Link
      className={className}
      sx={{
        fontSize: CPSConstants.FONTREMTEXT,
        pb: "1rem",
      }}
      href={href}
      target={target}>
      {outlet}
    </Link>
  );
};

export default FormLink;
